{
  "Clear search": "Obriši pretragu"
}
